import _sfc_main from "./WsSpinner.vue.es2.js";
/* empty css                  */
import _export_sfc from "../../_virtual/_plugin-vue_export-helper.es.js";
const WsSpinner = /* @__PURE__ */ _export_sfc(_sfc_main, [["__scopeId", "data-v-3705dffc"]]);
export {
  WsSpinner as default
};
//# sourceMappingURL=WsSpinner.vue.es.js.map
